import { observable, action } from 'mobx'
import Api from '@api/hotel/settlementManage'
import { message } from 'hljd'

class Store {
  @observable title = ''
  @observable id = ''
  @observable status = 0
  @observable price = 0

  @observable pay = '1'
  @action
  changePay = value => () => {
    this.pay = value
  }

  apiName = '/p/wedding/Admin/APIHotelSettleOrder/Pay'
  return_url = 'hotel/settlementManage'

  @action
  toPay = () => {
    const { pay, id, title, apiName, return_url, price } = this
    if (pay == '1') {
      this.offlinePay()
    } else {
      window.location.href = `#/localMerchant/cashier?price=${price}&title=${title}&apiName=${apiName}&return_url=${return_url}&payParams={"order_id":"${id}","pay_type":"online"}`
    }
  }
  @action
  offlinePay = async () => {
    const { id } = this
    let { msg, RetCode } = await Api.payApi({
      order_id: id,
      pay_type: 'offline'
    })
    if (RetCode == 0) {
      this.status = '1'
      window.location.href = '#/localMerchant/hoterCashier/remittance?id=' + id
    } else {
      return message.warning(msg)
    }
  }
}
export default new Store()
